if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.querySelector('.sm-direct-checkout')?.addEventListener('click', () => {
          if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;
          this.smDirectCheckout = true;
          this.form.requestSubmit(this.submitButton);
        });
      }

      async confirmStickerMasterSelection() {
        const area = this.closest('product-info, .product, quick-add-modal, .shopify-section') || document;
        const rawTitle = area.querySelector('.product__title h1, .product__title h2, .product__title')?.textContent?.trim() || document.title.split('–')[0].trim();
        const productName = rawTitle.replace(/\s+/g,' ').split('|')[0].trim();
        const choices = [];
        area.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input, variant-selects select, variant-radios fieldset, variant-radios select').forEach(group => {
          if (group.tagName === 'SELECT') {
            const name = group.closest('.product-form__input')?.querySelector('label')?.textContent?.trim() || group.name || 'Seçenek';
            if (group.selectedOptions[0]) choices.push([name, group.selectedOptions[0].textContent.trim()]);
          } else if (group.tagName === 'FIELDSET') {
            const chosen = group.querySelector('input:checked');
            if (chosen) choices.push([group.querySelector('legend')?.textContent?.trim() || 'Seçenek', chosen.value]);
          }
        });
        if (!choices.length) {
          area.querySelectorAll('variant-selects .product-form__input select, variant-selects fieldset input:checked').forEach(el => choices.push([el.name || 'Seçenek', el.value]));
        }
        if (!choices.length) {
          const label = area.querySelector('.product-form__input input:checked, .product-form__input select');
          if (label) choices.push(['Seçilen varyant', label.value]);
        }
        // Include personalized line-item properties and customer-entered text.
        const seenPersonalizations = new Set();
        const addPersonalization = (name, value) => {
          const label = String(name || 'Kişiye özel bilgi').replace(/^properties\\[/, '').replace(/\\]$/, '').replace(/^_/, '').trim();
          const text = String(value || '').trim();
          if (!text || !label || label.startsWith('_')) return;
          const key = label.toLocaleLowerCase('tr') + ':' + text;
          if (seenPersonalizations.has(key)) return;
          seenPersonalizations.add(key);
          choices.push([/yazınızı girin|yazinizi girin/i.test(label) ? 'Kişiye Özel Yazı' : label, text]);
        };
        const inputFields = new Set([
          ...this.form.querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]'),
          ...area.querySelectorAll('input[name^="properties["], textarea[name^="properties["], select[name^="properties["]')
        ]);
        inputFields.forEach(field => {
          if (field.disabled || ['hidden','file','password'].includes(field.type) || ((field.type === 'checkbox' || field.type === 'radio') && !field.checked)) return;
          const label = field.closest('.field, .product-form__input, .line-item-property')?.querySelector('label')?.textContent?.trim() || field.labels?.[0]?.textContent?.trim() || field.name;
          addPersonalization(label, field.value);
        });
        // Some personalization apps use text fields outside the product form.
        area.querySelectorAll('input[type="text"], textarea').forEach(field => {
          if (field.disabled || field.closest('form[action*="/search"], form[action*="/account"], form[action*="/contact"]')) return;
          if (field.name === 'quantity' || field.name === 'id' || field.name?.startsWith('properties[')) return;
          const label = field.labels?.[0]?.textContent?.trim() || field.closest('.field, .product-form__input')?.querySelector('label')?.textContent?.trim();
          if (label && /isim|ad\\b|yazı|yazi|plaka|numara|kişisel|kisisel|ince|zarif|metin|text/i.test(label + ' ' + field.name)) addPersonalization(label, field.value);
        });
        if (!choices.length) return true;
        return new Promise(resolve => {
          const overlay = document.createElement('div');
          overlay.setAttribute('role','presentation');
          overlay.style.cssText = 'position:fixed;inset:0;z-index:2147483000;background:rgba(0,0,0,.6);display:flex;align-items:center;justify-content:center;padding:18px';
          const dialog = document.createElement('div');
          dialog.setAttribute('role','dialog');dialog.setAttribute('aria-modal','true');dialog.setAttribute('aria-label','Siparişinizi kontrol edin');
          dialog.style.cssText = 'background:#fff;color:#171717;border-radius:16px;padding:20px;width:min(100%,420px);max-height:85dvh;overflow:auto;box-shadow:0 18px 70px #0005;font-family:var(--font-body-family),sans-serif';
          const heading = document.createElement('h2');heading.textContent='Siparişinizi Kontrol Edin';heading.style.cssText='font-size:20px;margin:0 0 7px;font-weight:700';
          const intro = document.createElement('p');intro.textContent='Sepete eklemeden önce ürün ve seçeneklerinizi doğrulayın.';intro.style.cssText='font-size:13px;color:#555;margin:0 0 12px';
          const product = document.createElement('p');product.textContent=productName;product.style.cssText='font-size:14px;font-weight:700;margin:0;line-height:1.4';
          const picture = area.querySelector('.product__media img, .product__media-list img, .product__media-item img, .card__media img');
          const summary=document.createElement('div');summary.style.cssText='display:flex;gap:14px;align-items:center;margin-bottom:12px';
          if(picture){const photo=document.createElement('img');photo.src=picture.currentSrc||picture.src;photo.alt=productName;photo.style.cssText='width:76px;height:76px;object-fit:contain;border-radius:8px;background:#f5f5f5';summary.append(photo);}
          summary.append(product);
          dialog.append(heading,intro,summary);
          choices.forEach(([name,value]) => {
            const item=document.createElement('div');item.style.cssText='padding:7px 0;border-top:1px solid #e5e5e5;font-size:15px';
            const label=document.createElement('span');label.textContent=name+': ';label.style.color='#555';
            const val=document.createElement('strong');val.textContent=value;item.append(label,val);dialog.append(item);
          });
          const prompt=document.createElement('p');prompt.textContent='Bu seçeneklerle sipariş vermek istediğinize emin misiniz?';prompt.style.cssText='font-size:14px;font-weight:600;margin:12px 0';
          const yes=document.createElement('button');yes.type='button';yes.textContent='Seçimim Doğru, Devam Et';yes.style.cssText='display:block;width:100%;background:#df1825;color:white;border:0;border-radius:7px;padding:12px;font-size:14px;font-weight:700;cursor:pointer';
          const no=document.createElement('button');no.type='button';no.textContent='Hayır, Seçimlerimi Değiştir';no.style.cssText='display:block;width:100%;background:white;color:#222;border:1px solid #bbb;border-radius:7px;padding:11px;margin-top:8px;font-size:14px;cursor:pointer';
          const consent=document.createElement('p');consent.textContent='Seçtiğim ürünün model, renk, ölçü ve diğer varyant bilgilerinin doğruluğunu kontrol ettim ve onaylıyorum.';consent.style.cssText='font-size:11px;color:#666;line-height:1.45;margin:10px 0 0';
          dialog.append(yes,no,consent);overlay.append(dialog);document.body.append(overlay);
          const prior=document.activeElement; const finish=value=>{document.removeEventListener('keydown',esc);overlay.remove();prior?.focus?.();resolve(value)};
          const esc=e=>{if(e.key==='Escape')finish(false)};
          document.addEventListener('keydown',esc);
          yes.addEventListener('click',()=>finish(true),{once:true});no.addEventListener('click',()=>finish(false),{once:true});
          overlay.addEventListener('click',e=>{if(e.target===overlay)finish(false)});
          yes.focus();
        });
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (!(await this.confirmStickerMasterSelection())) return;
        const directCheckout = this.smDirectCheckout === true;
        this.smDirectCheckout = false;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = directCheckout ? '/checkout' : window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);
            if (directCheckout) { window.location.href = '/checkout'; return; }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
